<template>
  <div class="dossier">
    <v-container class="loading" v-if="loading">
      <div>
        <span class="white--text">Идет сбор информации о студенте. Подождите, пожалуйста...</span>
      </div>
      <Loading
      :active.sync="loading"
      :color="loadingColor"
      :height="loadingHeight"
      :width="loadingWidth"
      :loader="loader"
      ></Loading>
    </v-container>

    <v-alert
      v-if="error"
      :value="true"
      type="error"
    >
      {{error}}
    </v-alert>

    <UserMainInfo
      v-if="userInfo && statuses"
      :user-info="userInfo"
      :statuses="statuses"
    ></UserMainInfo>

    <Weeks
      v-if="weeks && !filter"
      :weeks="weeks"
    ></Weeks>

    <ReviewFeedbacks
      v-if="filter && filter === 'reviewFeedbacks' && reviewFeedbacks"
      :reviewFeedbacks="reviewFeedbacks"
    ></ReviewFeedbacks>

    <Warnings
      v-if="filter && (filter === 'visibleWarnings') && warnings"
      :warnings="warnings"
    ></Warnings>

    <Drops
      v-if="filter && filter === 'drops' && drops"
      :drops="drops"
    ></Drops>

    <BestReviewer
      v-if="filter && filter === 'bestReviewer' && bestReviews"
      :reviews="bestReviews"
    ></BestReviewer>

    <InflatedMarks
      v-if="filter && filter === 'inflatedMarks' && inflatedMarks"
      :marks="inflatedMarks"
    ></InflatedMarks>
  </div>
</template>

<script>
  import Vue from "vue";
  import Weeks from "../components/Weeks";
  import UserMainInfo from "../components/user/UserMainInfo";
  import Loading from "vue-loading-overlay";
  import ReviewFeedbacks from "@/components/filter/ReviewFeedbacks";
  import Warnings from "@/components/filter/Warnings";
  import Drops from "@/components/filter/Drops";
  import BestReviewer from "@/components/filter/BestReviewer";
  import InflatedMarks from "@/components/filter/InflatedMarks";

  export default Vue.extend({
    components: {
      InflatedMarks,
      BestReviewer,
      Drops,
      Warnings,
      ReviewFeedbacks,
      Weeks,
      UserMainInfo,
      Loading
    },

    props: ["id"],

    data() {
      return {
        loading: false,
        loadingWidth: 60,
        loadingHeight: 60,
        loadingColor: "#FFEE58",
        loader: "dots",

        statuses: null,
        weeks: null,
        reviewFeedbacks: null,
        warnings: null,
        drops: null,
        userInfo: null,
        error: null,
        filter: null,
        bestReviews: null,
        inflatedMarks: null,

      }
    },

    created() {
      this.fetchData()
    },

    watch: {
      "$route": "fetchData",

      "$store.state.filter": function() {
        this.filter = this.$store.state.filter
        switch (this.filter) {
          case 'reviewFeedbacks':
            this.reviewFeedbacks = this.getReviewFeedbacks();
            break;
          case 'visibleWarnings':
            this.warnings = this.getWarnings();
            break;
          case 'drops':
            this.drops = this.getDrops();
            break;
          case 'bestReviewer':
            this.bestReviews = this.getBestReviews();
            break;
          case 'inflatedMarks':
            this.inflatedMarks = this.getInflatedMarks();
            break;

        }
      },
    },

    methods: {
      async fetchData() {
        this.statuses = this.weeks = this.userInfo = this.error = null;
        this.loading = true;

        try {
          await this.$store.dispatch("getUserDossier", {userId: this.$route.params.id});
          this.statuses = this.$store.state.statuses;
          this.weeks = this.$store.state.weeks;
          this.userInfo = this.$store.state.userInfo;
          this.loading = false;
        } catch (e) {
          this.loading = false;
          this.error = e.message;
        }
      },
      getReviewFeedbacks() {
        const feedbacks = [];

        for (const week of this.weeks) {
          for (const review of week.reviews) {
            let feedback = null;

            if (review.eventName === 'reviewForReviewer') {
              feedback = {
                type: 'От проверяемого',
                level: review.data.examineeLevel,
                author: this.$store.state.users[review.data.examineeId],
                authorLevel: review.data.examineeLevel,
                message: review.data.feedbackFromExaminee.comment,
                mark: review.data.feedbackFromExaminee.mark,
                returnedMessage: review.data.feedbackFromReviewer.comment,
                returnedMark: review.data.feedbackFromReviewer.mark,
                duration: review.data.durationFromExaminee,
                returnedDuration: review.data.durationFromReviewer,
                bestReviewer: review.data.bestReviewer,
              }
            }

            if (review.eventName === 'reviewForExaminee') {
              feedback = {
                type: 'От ревьювера',
                level: review.data.examineeLevel,
                author: this.$store.state.users[review.data.reviewerId],
                authorLevel: review.data.reviewerLevel,
                message: review.data.feedbackFromReviewer.comment,
                mark: review.data.feedbackFromReviewer.mark,
                returnedMessage: review.data.feedbackFromExaminee.comment,
                returnedMark: review.data.feedbackFromExaminee.mark,
                duration: review.data.durationFromReviewer,
                returnedDuration: review.data.durationFromExaminee,
              }
            }

            if (feedback) {
              feedbacks.push({
                date: review.date,
                type: feedback.type,
                level: feedback.level,
                author: feedback.author,
                authorLevel: feedback.authorLevel,
                message: feedback.message,
                mark: feedback.mark,
                returnedMessage: feedback.returnedMessage,
                returnedMark: feedback.returnedMark,
                duration: feedback.duration,
                returnedDuration: feedback.returnedDuration,
                bestReviewer: feedback.bestReviewer || false,
                deleted: review.deleted,
              });
            }
          }
        }

        return feedbacks.filter((f) => f.mark || f.returnedMark);
      },

      getWarnings(hidden = false) {
        const warnings = [];

        for (const week of this.weeks) {
          for (const warning of week.warnings) {
            if (warning.data.hidden === hidden) {
              warnings.push({
                date: warning.date,
                message: warning.data.reason,
                level: warning.data.level,
                eduAttempt: warning.data.eduAttempt
              });
            }
          }
        }

        return warnings;
      },

      getDrops() {
        return this.weeks.filter((w) => w.drop.date).map((w) => {
          return {
            date: w.drop.date,
            message: w.drop.info,
            eduAttempt: w.drop.eduAttempt
          }
        });
      },

      getBestReviews() {
        const reviews = [];

        for (const week of this.weeks) {
          for (const review of week.reviews) {
            if (review.data.bestReviewer) {
              reviews.push({
                date: review.date,
                examinee: this.$store.state.users[review.data.examineeId],
                level: review.data.examineeLevel,
                message: review.data.feedbackFromExaminee.comment,
              });
            }
          }
        }

        return reviews;
      },

      getInflatedMarks() {
        const marks = [];

        for (const week of this.weeks) {
          for (const review of week.reviews) {
            if (review.eventName === 'reviewForReviewer') {
              for (const reviewNumber in review.data.marks) {
                for (const markData of review.data.marks[reviewNumber]) {
                  if (markData.inflated) {
                    marks.push({
                      date: review.date,
                      examinee: this.$store.state.users[review.data.examineeId],
                      level: review.data.examineeLevel,
                      task: markData.taskNumber,
                      mark: markData.mark,
                      message: markData.comment,
                      reason: markData.inflatedReason
                    });
                  }
                }
              }
            }
          }
        }

        return marks;
      }
    },
  });
</script>

<style>
  .loading {
    width: 100vw;
    height: calc(100vh - 130px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
</style>
